module.exports = __webpack_public_path__ + "img/trennwand.9f7bb294.jpg";